var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoof(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.56 26.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Roof") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-626,208.64a2.72,2.72,0,0,0,2.72-2.72v-3.55h-5.5v3.55a2.77,2.77,0,0,0,2.78,2.72h0Zm0,0",
    transform: "translate(628.78 -197.69)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-616.28,205.91v-3.55h-5.45v3.55a2.72,2.72,0,0,0,2.72,2.72,2.72,2.72,0,0,0,2.72-2.72h0Zm0,0",
    transform: "translate(628.78 -197.69)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-609.27,202.36h-5.45v3.55a2.72,2.72,0,0,0,2.72,2.72,2.72,2.72,0,0,0,2.72-2.72v-3.55Zm0,0",
    transform: "translate(628.78 -197.69)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-602.22,202.36h-5.5v3.55a2.72,2.72,0,0,0,2.72,2.72,2.77,2.77,0,0,0,2.78-2.72v-3.55Zm0,0",
    transform: "translate(628.78 -197.69)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-602.22,209.19a4.38,4.38,0,0,1-2.78,1,4.24,4.24,0,0,1-2.72-1v4.51a2.72,2.72,0,0,0,2.72,2.72,2.77,2.77,0,0,0,2.78-2.72v-4.51Zm0,0",
    transform: "translate(628.78 -197.69)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-609.27,209.19a4.24,4.24,0,0,1-2.72,1,4.24,4.24,0,0,1-2.72-1v4.51a2.72,2.72,0,0,0,2.72,2.72,2.72,2.72,0,0,0,2.72-2.72v-4.51Zm0,0",
    transform: "translate(628.78 -197.69)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-621.72,213.69a2.72,2.72,0,0,0,2.72,2.72,2.72,2.72,0,0,0,2.72-2.72v-4.51a4.24,4.24,0,0,1-2.72,1,4.24,4.24,0,0,1-2.72-1v4.51Zm0,0",
    transform: "translate(628.78 -197.69)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-626,216.42a2.72,2.72,0,0,0,2.72-2.72v-4.51a4.24,4.24,0,0,1-2.72,1,4.38,4.38,0,0,1-2.78-1v4.51a2.77,2.77,0,0,0,2.78,2.72h0Zm0,0",
    transform: "translate(628.78 -197.69)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-607.72,217v4.56a2.72,2.72,0,0,0,2.72,2.72,2.77,2.77,0,0,0,2.78-2.72V217a4.38,4.38,0,0,1-2.78,1,4.24,4.24,0,0,1-2.72-1h0Zm0,0",
    transform: "translate(628.78 -197.69)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-614.72,217v4.56a2.72,2.72,0,0,0,2.72,2.72,2.72,2.72,0,0,0,2.72-2.72V217a4.24,4.24,0,0,1-2.72,1,4.24,4.24,0,0,1-2.72-1h0Zm0,0",
    transform: "translate(628.78 -197.69)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-621.72,221.53a2.72,2.72,0,0,0,2.72,2.72,2.72,2.72,0,0,0,2.72-2.72V217a4.24,4.24,0,0,1-2.72,1,4.24,4.24,0,0,1-2.72-1v4.56Zm0,0",
    transform: "translate(628.78 -197.69)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-626,224.25a2.72,2.72,0,0,0,2.72-2.72V217a4.24,4.24,0,0,1-2.72,1,4.38,4.38,0,0,1-2.78-1v4.56a2.77,2.77,0,0,0,2.78,2.72h0Zm0,0",
    transform: "translate(628.78 -197.69)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    width: 26.56,
    height: 3.11
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoof);
export default __webpack_public_path__ + "static/media/Roof.afd1b420.svg";
export { ForwardRef as ReactComponent };